import React from "react";
import pmgsHipTag from "./../../../../assets/NPG for agenda.svg";

export const PmgsHipimage = ({ className, isValidProject }) => {
  return isValidProject ? (
    <div className={className}>
      <img src={pmgsHipTag} />
    </div>
  ) : null;
};
